import { Component, type ReactNode } from 'react'
import {
  isStaleAssetError,
  requestRequiredAppUpdate,
} from '../../../shared/errors/app-update-required'

export class StoryViewerBoundary extends Component<
  { children: ReactNode; onUnavailable: () => void },
  { failed: boolean }
> {
  state = { failed: false }
  static getDerivedStateFromError() {
    return { failed: true }
  }
  componentDidCatch(error: unknown) {
    if (isStaleAssetError(error)) requestRequiredAppUpdate()
    this.props.onUnavailable()
  }
  render() {
    return this.state.failed ? null : this.props.children
  }
}
